export interface Filter {
  key: string | Array<any>;
  name: string;
  options: any;
  type: FilterType;
  selected: FilterSelected;
  quicks?: Array<QuickFilter>;
}

export interface QuickFilter {
  title: string;
  id: string;
  value?: any;
}
export interface FilterSelected {
  id: string;
  label: string;
  display: string;
  value: any;
  op?: string;
}


export enum FilterType {
 List,
 Input,
 DateRange,
 Multi,
}
